// extracted by mini-css-extract-plugin
export default {"purple01":"#B4BFD6","sharedLink":"SharedLinkRowDark__sharedLink___PUYKV","link":"SharedLinkRowDark__link___omjeT"};